<app-modal-dialog></app-modal-dialog>
<app-header></app-header>
<app-scan *ngIf="isScan" [mode]="mode" (subtitleClick)="showPage($event)"></app-scan>
<app-video-page *ngIf="!isScan" [imageDetail]="imageDetail" (toggleScan)="showScanPage($event)"></app-video-page>
